var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg25(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7456 16.4334H23.7159C25.2355 15.4797 26.3627 13.9584 26.8003 12.1667H31L30.8362 12.6909C30.1404 14.9174 28.0783 16.4334 25.7456 16.4334Z",
    fill: "#FAB215"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3849 21.7851C22.6708 19.6809 20.6789 18.1667 18.3333 18.1667H9V19.5001C9 23.9184 12.5817 27.5001 17 27.5001H19.1434C21.2246 26.2461 22.7765 24.203 23.3849 21.7851Z",
    fill: "url(#paint0_linear_887_4791)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 3.5C16.134 3.5 13 6.63401 13 10.5C13 11.8444 13.379 13.1003 14.036 14.1667H7.12023C4.59508 14.1667 2.28666 12.74 1.15738 10.4814L1 10.1667V18.1667C1 24.0577 5.77563 28.8333 11.6667 28.8333H14.3333C16.0929 28.8333 17.7387 28.3464 19.1434 27.5H17C12.5817 27.5 9 23.9183 9 19.5V18.1667H18.3333C20.6789 18.1667 22.6708 19.6808 23.3849 21.785C23.5689 21.0538 23.6667 20.2883 23.6667 19.5V16.464C25.6667 15.2318 27 13.0216 27 10.5C27 6.63401 23.866 3.5 20 3.5ZM21.6667 9.5C20.5621 9.5 19.6667 10.3954 19.6667 11.5C19.6667 12.6046 20.5621 13.5 21.6667 13.5C22.7712 13.5 23.6667 12.6046 23.6667 11.5C23.6667 10.3954 22.7712 9.5 21.6667 9.5Z",
    fill: "url(#paint1_linear_887_4791)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_887_4791",
    x1: 21,
    y1: 26.1667,
    x2: 13.633,
    y2: 15.0795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_887_4791",
    x1: 4.82353,
    y1: 26.3817,
    x2: 26.7279,
    y2: 7.40279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg25);
export default __webpack_public_path__ + "static/media/25.5a3028b5a222bf34175d5c8ad0a8fc3c.svg";
export { ForwardRef as ReactComponent };